import store from '@/store'
import Vue from 'vue'

export default async (to, from, next) => {
  const vm = new Vue()
  try {
    store.dispatch('wait/start', 'app loading', { root: true })

    await store.dispatch('SystemConfig/fetchSystemConfigs', 'MAXIMUM_PERIOD_PRE_ORDER')

    next()
  } catch (error) {
    await vm.$swal({
      icon: 'warning',
      title: 'เกิดข้อผิดพลาด',
      html: 'ขออภัย เกิดข้อผิดพลาดระหว่างการดำเนินการ<br>กรุณาลองใหม่อีกครั้ง'
    })
    throw new Error(error)
  } finally {
    store.dispatch('wait/end', 'app loading', { root: true })
  }
}
